import { FinancingConfigDto } from '@applyonline/shared'
import { t } from '@if/core/i18n'
import * as yup from '@if/core/yup'
import { useMemo } from 'react'

export function usePromoCodeYupValidator() {
  return useMemo(
    () =>
      yup
        .string()
        .matches(/^[a-zA-Z0-9]+$/)
        .nullable()
        .default(null)
        .emptyToNull(),
    [],
  )
}

function buildWorksheetSchema(
  availableCredit: number,
  amountRequested: number,
  term: number,
  financingProgramConfig: FinancingConfigDto,
) {
  return yup.object({
    merchantPaymentPlanId: yup.string().nullable().default(null),
    amountRequested: yup
      .double()
      .required()
      .default(amountRequested)
      .min(financingProgramConfig.minimumLoanAmount, () =>
        t('worksheet.error.between', { min: financingProgramConfig.minimumLoanAmount, max: availableCredit }),
      )
      .max(availableCredit, () =>
        t('worksheet.error.between', { min: financingProgramConfig.minimumLoanAmount, max: availableCredit }),
      ),
    term: yup.integer().required().default(term),
    firstPaymentOn: yup.string().validDate().required(),
    includeInsurance: yup.boolean().required(),
  })
}
export function useWorksheetSchema(
  availableCredit: number,
  amountRequested: number,
  term: number,
  financingProgramConfig: FinancingConfigDto,
) {
  return useMemo(
    () => buildWorksheetSchema(availableCredit, amountRequested, term, financingProgramConfig),
    [availableCredit, amountRequested, term, financingProgramConfig],
  )
}

export type WorksheetForm = yup.InferSubmit<ReturnType<typeof buildWorksheetSchema>>
